import { render, staticRenderFns } from "./SBCustomWrapperJSONForms.vue?vue&type=template&id=6d3bfab0&scoped=true&"
import script from "./SBCustomWrapperJSONForms.vue?vue&type=script&lang=js&"
export * from "./SBCustomWrapperJSONForms.vue?vue&type=script&lang=js&"
import style0 from "./SBCustomWrapperJSONForms.vue?vue&type=style&index=0&id=6d3bfab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3bfab0",
  null
  
)

export default component.exports